/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DateTimeRoundType {
  None = 'None',
  BeginOfDay = 'BeginOfDay',
  EndOfDay = 'EndOfDay',
  BeginOfMonth = 'BeginOfMonth',
  EndOfMonth = 'EndOfMonth',
  BeginOfQuarterYear = 'BeginOfQuarterYear',
  EndOfQuarterYear = 'EndOfQuarterYear',
  BeginOfYear = 'BeginOfYear',
  EndOfYear = 'EndOfYear'
}
